import { io, Socket } from 'socket.io-client';
import { Incident } from '../types/domain';
import { publicEnv } from '../config/env';

let socket: Socket | undefined;

export function getSocket(): Socket {
  if (!socket) {
    socket = io(publicEnv.socketUrl, {
      transports: ['websocket']
    });
  }
  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = undefined;
}

export function publishIncident(incident: Incident): void {
  getSocket().emit('incident:create', incident);
}

export function joinRoom(roomId: string): void {
  getSocket().emit('room:join', { roomId });
}

export function leaveRoom(roomId: string): void {
  getSocket().emit('room:leave', { roomId });
}

export function endWebRtcSession(roomId: string): void {
  getSocket().emit('webrtc:session-ended', { roomId });
}

export function signalPeer(roomId: string, payload: unknown): void {
  getSocket().emit('webrtc:signal', { roomId, payload });
}
